// src/landing/components/HowSection.js
import React, { useContext } from 'react';
import '../styles/HowSection.css';
import { LanguageContext } from '../../common/contexts/LanguageContext';

export default function HowSection() {
  const { t } = useContext(LanguageContext);
  const steps = t('howSection.steps') || [];

  return (
    <section id="how" className="how">
      <h2>{t('howSection.title')}</h2>
      <p className="subtitle">{t('howSection.subtitle')}</p>

      <div className="cards">
        {steps.map((step, idx) => {
          // public/img 폴더에 있는 파일을 가리키도록 PUBLIC_URL 사용
          // JSON 에 img 에 파일명만 ("how_install.png" 등)을 넣어두세요.
          const imgSrc = `${process.env.PUBLIC_URL}/img/${step.img}`;

          return (
            <article key={idx} className="how-card">
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
              <img src={imgSrc} alt={step.title} />
            </article>
          );
        })}
      </div>
    </section>
  );
}
